import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../../../contexts/AppContextProvider";
import {Button, Card, Grid} from "@mui/material";
import {CustomerAddress} from "../../../contexts/types";
import makeStyles from "@mui/styles/makeStyles";
import {OrgCustomizationContext} from "../../../themes/OrgCustomizationProvider";

const useStyles = makeStyles(theme => ({
    card: {
        padding: 15,
        background: theme.palette.grey[100],
        height: '100%'
    },
    activeCard: {
        padding: 15,
        background: theme.palette.grey[100],
        border: `${theme.palette.primary.main} 2px solid`,
        height: '100%'
    }
}))

type AddressCardProps = {
    address: CustomerAddress,
    active?: boolean,
    onSelect: React.Dispatch<string>,
    selectText: string
}

const AddressCard: React.FC<AddressCardProps> = ({address, active, onSelect, selectText}) => {
    const classes = useStyles()

    return (
        <Card className={active ? classes.activeCard : classes.card}>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%'}}>
                <div>
                    <p>{address.name1}</p>
                    <p>{address.street}</p>
                    <p>{address.postalCode}</p>
                    <p>{address.city}</p>
                    <p>{address.region}</p>
                    <p>{address.country}</p>
                </div>
                <div>
                    {!active && <Button onClick={() => onSelect(address.customer)} variant='contained' color='secondary'
                                        style={{width: '100%'}}>{selectText}</Button>}
                </div>
            </div>
        </Card>
    )
}

type AddressSelectorProps = {
    partnerAddressType?: string[]
    value?: CustomerAddress
    onChange?: (address?: CustomerAddress) => void
}

const AddressSelector: React.FC<AddressSelectorProps> = ({partnerAddressType, value, onChange}) => {
    const { t } = useContext(OrgCustomizationContext)
    const {addresses: masterAddresses} = useContext(AppContext)
    const [ addressList, setAddressList ] = useState<CustomerAddress[]>([])
    
    useEffect( () => 
        setAddressList(masterAddresses?.filter(address => partnerAddressType?.includes(address.partner))), 
        [masterAddresses, partnerAddressType]
    )

    return (
        <Grid container spacing={3}>
            {addressList?.map((a, i) =>
                <Grid item xs={12} sm={6} md={4} key={i}>
                    <AddressCard address={a} active={a.customer === value?.customer}
                                 selectText={t('sa_select_replacement_shipping_address')}
                                 onSelect={() => onChange ? onChange(a) : undefined}/>
                </Grid>
            )}
        </Grid>
    )
}

export default AddressSelector
